import { PagedResultGeneric } from 'src/app/shared/model/paged-result.model';
import { TaskSearchGridComponent } from '../../tasks/task-search-grid/task-search-grid.component';
import { TaskSearchDto } from '../../tasks/shared/dto/task-search.dto';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TaskDto } from 'src/app/tasks/shared/dto/task.dto';
import { FeatureService } from 'src/app/shared/feature/feature.service';
import { FeatureNameEnum } from 'src/app/shared/feature/feature-name.enum';
import { UserService } from 'src/app/users/shared/user.service';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-profile-tasks-search',
  templateUrl: './profile-tasks-search.component.html',
  styleUrls: ['./profile-tasks-search.component.less'],
    standalone: false
})
export class ProfileTasksSearchComponent implements OnInit {
  tasksSearchResult: PagedResultGeneric<TaskDto>;
  searchParams = new TaskSearchDto();
  hasProjects = false;
  profileModuleFullAccess: boolean = false;
  profileTasksTabFullAccess: boolean = false;

  @ViewChild(TaskSearchGridComponent) taskSearchGrid: TaskSearchGridComponent;

  constructor(private _featureService: FeatureService, private _userService: UserService) {}

  ngOnInit(): void {
    this.searchParams.OrderBy = 'DateDue';
    this._featureService.has(FeatureNameEnum.Projects).then((data) => {
      this.hasProjects = data;
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileTasks_Tab').then((userAccessLevel: number) => {
          this.profileTasksTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  clear() {
    this.taskSearchGrid.fullLazyLoad = false;
    this.taskSearchGrid.taskSearchResult = { Result: [] } as PagedResultGeneric<TaskDto>;
    this.tasksSearchResult = { Result: [] } as PagedResultGeneric<TaskDto>;
    this.searchParams = new TaskSearchDto();
  }
}
